module.exports = __webpack_public_path__ + "img/solena-tomate.3c19102e.png";